//Platform image import
// import enterprise from "../../assets/images/logo-enterprise-search-32-color.svg";
// import observability from "../../assets/images/logo-observability-32-color.svg";
// import security from "../../assets/images/logo-security-32-color.svg";
// import elastic from "../../assets/images/logo-cloud-32-color.svg";
// import stack from "../../assets/images/logo-stack-32-color.svg";
import Whatsapp from "../../assets/images/Whatsapp.png";
import Instagram from "../../assets/images/Instagram.png";
import Facebook from "../../assets/images/Facebook.png";
import WebSite from "../../assets/images/WebSite.png";
import Email from "../../assets/images/E-mail.png";

// Customers Image import
import jaguar from '../../assets/images/Jaguar.jpg'
import emirates from '../../assets/images/icone.jpg'
import zurich from '../../assets/images/icone.jpg'

// Resources Image import
import document from '../../assets/images/bot.jpg'
import demand from '../../assets/images/bot.jpg'
import award from '../../assets/images/bot.jpg'

// Icons
import arrowDown from '../../assets/images/arrowDown.png'

// Platform Data
export const Links = [
  {
    name: "Plataforma",
    submenu: true,
    sublinks: [
      {
        // Head: ["ELASTIC CLOUD"],
        sublink: [
          {
            heading: "Maximize o valor e otimize sua experiência",
            des: "Implante atendimento automático, em minutos.",
            learn: "Saiba mais",
            additional: "RECURSOS ADICIONAIS",
            pricing: "Ver preços",
            downloads: "Experimente grátis",
            integrations: "Ver todas as integrações",
            link: "/maximize",
          },
        ],
      },

      {
        // Head: "USE ELASTIC FOR",
        sublink: [
          {
            img: Whatsapp,
            heading: "Whatsapp",
            des: "Automatize o atendimento",
            link: "/digitalMarketingService",
          },
          {
            img: Instagram,
            heading: "Instagram",
            des: "Interações automatizadas",
            link: "/digitalMarketingService",
          },
          {
            img: Facebook,
            heading: "Facebook",
            des: "Interações automatizadas",
            link: "/digitalMarketingService",
          },
          {
            img: Email,
            heading: "E-Mail",
            des: "Envio automatizado",
            link: "/digitalMarketingService",
          },
          {
            img: WebSite,
            heading: "WebSites",
            des: "Chatbot Humanizado",
            link: "/digitalMarketingService",
          },
        ],
      },

      {
        
        sublink: [
          {
            heading: "Agentes de IA que respondem por você",
            des: "Atendentes 24h",
            link: "/digitalMarketingService",
          },
          {
            heading: "Interpretação de mensagens Texto e Áudio",
            des: "transcreve áudios para texto e fornecendo respostas rápidas e precisas",
            link: "/digitalMarketingService",
          },
          {
            heading: "Integração de Sistemas CRM",
            des: "Seus bots consulta uma base de dados para respostas precisas",
            link: "/digitalMarketingService",
          },
          {
            heading: "Documetação completa",
            des: "Você controla o comportamento de suas automações",
            link: "/digitalMarketingService",
          },
          
        ],
      },
    ],
  },
];

// useCases Data
export const useCaseData = [
  {
    name: "Caso de uso ",
    submenu: true,
    sublinks: [
      // By Topic
      {
        sublink: [
          {
            heading: "O Poder da Automação",
            link: "/maximize",
          },
          {
            heading: "Melhorando a experiência digital do cliente",
            link: "/maximize",
          },
          {
            heading: "Evoluindo o ciclo de vida do DevOps",
            link: "/maximize",
          },
          {
            heading: "Segurança sem limites",
            link: "/maximize",
          },
        ],
      },

      // By Industry
      {
        sublink: [
          {
            heading: "Setor Público",
            link: "/digitalMarketingService",
          },
          {
            heading: "Serviços Financeiros",
            link: "/digitalMarketingService",
          },
          {
            heading: "Telecomunicações",
            link: "/digitalMarketingService",
          },
          {
            heading: "Assistência médica",
            link: "/digitalMarketingService",
          },
          {
            heading: "Tecnologia",
            link: "/digitalMarketingService",
          },
          {
            heading: "Varejo e comércio eletrônico",
            link: "/digitalMarketingService",
          },
          {
            heading: "Pizzaria, Hamburgueria e Restaurantes",
            link: "/digitalMarketingService",
          },
          {
            heading: "Barbearia, Salão de Beleza",
            link: "/digitalMarketingService",
          },
        ],
      },
    ],
  },
];

// Customers Data
export const CustomersData = [
  {
    name: "Clientes",
    submenu: true,
    sublinks: [
      {
        sublink: [
          {
            heading: "Pesquisa Empresarial",
            des: "Aplicativos de pesquisa de todos os tipos",
            link: "/maximize",
          },
          {
            heading: "Observabilidade",
            des: "Logs, métricas, APM e muito mais",
            link: "/maximize",
          },
          {
            heading: "Segurança",
            des: "SIEM, endpoint, nuvem e XDR",
            link: "/maximize",
          },
        ],
      },

      {
        // Head: "WHAT'S NEW",
        sublink: [
          {
            heading: "Introdução",
            des: "Orientações para começar",
            link: "/digitalMarketingService",
          },
          {
            heading: "Suporte",
            des: "Obtenha ajuda e recursos para clientes",
            link: "/digitalMarketingService",
          },
          {
            heading: "Contato",
            des: "Tem dúvidas? Entre em contato",
            link: "/digitalMarketingService",
          },
        ],
      },
      {
        // Head: "USE ELASTIC FOR",
        sublink: [
          {
            img: jaguar,
            heading: "Prefeitura M. de Ceres",
            des: "",
            link: "/digitalMarketingService",
          },
          {
            img: emirates,
            heading: "Secretaria de Saúde de Ceres",
            des: "",
            link: "/digitalMarketingService",
          },
          {
            img: zurich,
            heading: "Secretaria de Educação",
            des: "",
            link: "/digitalMarketingService",
          },
        ],
      },
    ],
  },
];

// Resources Data
export const ResourcesData = [
  {
    name: "Recursos",
    submenu: true,
    sublinks: [
      {
        sublink: [
          {
            heading: "Qualificação de leads",
            des: " Essa prática permite que as equipes de vendas e marketing foquem seus esforços nos contatos com maior potencial de conversão, aumentando a eficiência e as chances de sucesso. ",
            link: "/maximize",
          },
          {
            heading: "Remarketing",
            des: "O objetivo é lembrar a pessoa do seu produto ou serviço e incentivá-la a realizar uma ação desejada, como uma compra. ",
            link: "/maximize",
          },
          {
            heading: "Vendas 24 horas por dia",
            des: "7 dias por semana",
            link: "/maximize",
          },
        ],
      },

      {
        // Head: "WHAT'S NEW",
        sublink: [
          {
            heading: "Eventos",
            des: "Atende24h encontros, eventos virtuais",
            link: "/digitalMarketingService",
          },
          {
            heading: "Comunidade",
            des: "Grupos, forums",
            link: "/digitalMarketingService",
          },
          {
            heading: "Consultoria",
            des: "Serviços baseados em resultados",
            link: "/digitalMarketingService",
          },
        ],
      },
      {
        // Head: "USE ELASTIC FOR",
        sublink: [
          {
            img: document,
            heading:
              "Plataforma de Multi Atendimento",
            link: "/digitalMarketingService",
          },
          {
            img: demand,
            heading: "Chatbot para Websites com respostas humanizadas",
            link: "/digitalMarketingService",
          },
          {
            img: award,
            heading: "Controle Centralizado de conversas no Whatsapp",
            link: "/digitalMarketingService",
          },
        ],
      },
    ],
  },
];

// Company Data
export const CompanyData = [
  {
    name: "Empresa",
    submenu: true,
    sublinks: [
      // By Topic
      {
        sublink: [
          {
            heading: "Sobre",
            des: "Nossa história e liderança",
            link: "/maximize",
          },
          {
            heading: "Carreiras",
            des: "Confira nossas oportunidades",
            link: "/maximize",
          },
          {
            heading: "Notícias",
            des: "Fique por dentro das tecnologias",
            link: "/maximize",
          },
        ],
      },

      // By Industry
      {
        sublink: [
          {
            heading: "Parceiros",
            des: "Encontre o produto ou torne-se um parceiro",
            link: "/maximize",
          },
          {
            heading: "Relações com Investidores",
            des: "Resultados, registros, recursos",
            link: "/maximize",
          },
          {
            heading: "Prêmios de Excelência",
            des: "Veja trabalhos notáveis",
            link: "/maximize",
          },
        ],
      },
    ],
  },
];
